<template>
  <el-dialog
    ref="bm"
    :title="$t(title)"
    :visible.sync="dialogVisible"
    :width="width"
    :close-on-click-modal="false"
    :top="top"
    :destroy-on-close="true"
    :show-close="show_close"
    :modal-append-to-body="modal"
    :modal="mask"
  >
    <slot name="modal_content"></slot>
    <span slot="footer" v-if="!hideFooter">
      <el-button
        type="info"
        class="iconfont icon-cancel"
        size="small"
        @click="cancel"
        >&nbsp;取 消</el-button
      >
      <el-button
        type="success"
        class="iconfont icon-save"
        size="small"
        @click="saveData"
        :loading="is_loading"
        >&nbsp;{{ saveButtonTitle }}
      </el-button>
    </span>
  </el-dialog>
  <!-- <b-modal ref="bm" no-close-on-backdrop :title="title" header-text-variant="light" :hide-footer="hideFooter" centered :size="size" ok-variant="warning" @hide="is_loading = false" :header-class="ModalTheme">
    <template #default="{}">
      <slot name="modal_content"></slot>
    </template>

    <template #modal-footer="{ hide }">
      <el-button type="info" class="iconfont icon-cancel" size="small" @click="hide()">&nbsp;取 消</el-button>
      <el-button type="success" class="iconfont icon-save" size="small" @click="saveData" :loading="is_loading">&nbsp;保 存</el-button>
    </template>
  </b-modal> -->
</template>
<script>
export default {
  name: 'baseModal',
  props: {
    title: {
      type: String,
      default: '提示',
    },
    size: {
      type: String,
      default: 'lg',
    },
    hideFooter: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: '40%',
    },
    saveButtonTitle: {
      type: String,
      default: '保 存',
    },
    top: {
      type: String,
      default: '15vh',
    },
    show_close: {
      type: Boolean,
      default: true,
    },
    modal: {
      type: Boolean,
      default: true,
    },
    mask: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      is_loading: false,
      ModalTheme: 'ModalTheme',
      dialogVisible: false,
    };
  },
  created() {},
  methods: {
    show() {
      let theme = localStorage.getItem('theme');
      if (theme) {
        if (theme == 'yellow') {
          this.ModalTheme = 'ModalTheme';
        }
        if (theme == 'blue') {
          this.ModalTheme = 'ModalTheme1';
        }
        if (theme == 'green') {
          this.ModalTheme = 'ModalTheme2';
        }
        if (theme == 'gray') {
          this.ModalTheme = '';
        }
      }
      // this.$refs.bm.show()
      this.dialogVisible = true;
    },

    saveData: _.debounce(
      function (evt) {
        evt.preventDefault();
        let _this = this;
        if (this.is_loading === true) return;
        this.is_loading = true;
        this.$emit('saveData', (is_validated, action_state, msg) => {
          this.is_loading = false;
          if (_.isNull(is_validated)) {
            return;
          }
          if (is_validated) {
            if (action_state) {
              _this.msgToasts(this.$t('notify.action_successfully'), 'success');
              _this.dialogVisible = false;
              // _this.$refs.bm.hide()
            } else {
              this.msgToasts(
                this.$t('notify.action_unsuccessfully') + msg,
                'error'
              );
            }
          } else {
            _this.dialogVisible = false;
          }
        });
      },
      1000,
      { leading: false, trailing: true }
    ),
    cancel() {
      this.dialogVisible = false;
      this.is_loading = false;
    },
  },
};
</script>
<style>
.modal-header {
  padding: 0.5rem 1rem;
}
.modal-footer {
  padding: 0.5rem;
}
</style>
